import React, { useState } from "react";

import ImageSlider from "./ImageSlider";
import styles from "./projectdetails.module.scss";
import AttentionBox from "./AttentionBox";
import Overview from "./Overview";
import ApplicationConditions from "./ApplicationConditions";
import ProjectDetailsHeader from "./ProjectDetailsHeader";
import ApplicationButton from "../application-button/ApplicationButton";
import BackToListButton from "../backtolistbutton/BackToListButton";
import ProjectDetailsModalContainer from "../application-button/ProjectDetailsModalContainer";

import { SonicTermData } from "../../common/classes/SonicTerm";
import {
  calcRemainingDays,
  getDefaultImage,
  getTimestampToday,
} from "../../utils/GeneralUtils";
import RegistLeader from "../../common/RegistLeader";
import ProjectDetailsSectionTitle from "./ProjectDetailsSectionTitle";
import MainGame from "../person-single/MainGame";
import ContentReportModalContainer from "../../common/report/ContentReportModalContainer";
import { PageTypes } from "../../utils/PageTypes";
import { QueryKey } from "@tanstack/react-query";
import PageNotificationBanner from "../../common/PageNotificationBanner";

type Props = {
  id?: string;
  title?: string;
  type?: SonicTermData;
  ownerId: string;
  ownerName: string;
  ownerChatDenial: boolean;
  question?: string;
  imgs?: Array<string> | Array<File>;
  applicants?: Array<string>;
  end_date?: number;
  game?: Array<SonicTermData>;
  description?: string;
  requirements?: string;
  isUserLoggedIn: boolean;
  isUsersOwnProject: boolean;
  isUserApplied: boolean;
  refetchKey?: QueryKey;
  isJikei: boolean;
  relatedContents?: React.ReactNode;
};

export const ProjectDetails: React.FC<Props> = (props) => {
  const {
    id,
    title,
    type,
    ownerId,
    ownerName,
    ownerChatDenial,
    question,
    imgs,
    applicants,
    end_date,
    game,
    description,
    requirements,
    isUserLoggedIn,
    isUsersOwnProject,
    isUserApplied,
    refetchKey,
    isJikei,
    relatedContents,
  } = props;

  const [showModal, setShowModal] = useState<boolean>(false);
  const [isReportModalShown, setIsReportModalShown] = useState<boolean>(false);

  return (
    <>
      <main>
        <div className={styles["project-details"]}>
          <div className={styles["project-details__wrapper"]}>
            {end_date && end_date < getTimestampToday() ? (
              <PageNotificationBanner text="このプロジェクトは終了しました" />
            ) : null}
            <ImageSlider
              img={imgs && imgs.length !== 0 ? imgs : [getDefaultImage()]}
              type={type}
            />
            <div className={styles["project-details_bg"]}>
              {showModal ? (
                <div className={styles["modal-overlay"]}></div>
              ) : (
                <div className={styles["test"]}></div>
              )}
              <div className={styles["project-details-content"]}>
                {title && type && ownerName ? (
                  <ProjectDetailsHeader
                    isJikei={isJikei}
                    title={title}
                    type={type.name}
                    color={type.color}
                    owner={ownerName}
                    openModal={() => setIsReportModalShown(true)}
                  />
                ) : null}

                <AttentionBox
                  applicantsCount={applicants?.length}
                  endDate={end_date}
                />

                {description ? (
                  <div className={styles["project-details-content__item"]}>
                    <ProjectDetailsSectionTitle title={"プロジェクト概要"} />
                    <Overview description={description} />
                  </div>
                ) : null}
                {requirements ? (
                  <div className={styles["project-details-content__item"]}>
                    <ProjectDetailsSectionTitle title={"応募条件"} />
                    <ApplicationConditions requirements={requirements} />
                  </div>
                ) : null}
                {game && game.length > 0 ? (
                  <div className={styles["project-details-content__item"]}>
                    <ProjectDetailsSectionTitle title={"ゲーム"} />
                    <MainGame games={game} />
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          <div className={styles["project-details-content_footer"]}>
            {refetchKey &&
            !isUsersOwnProject &&
            (!end_date || calcRemainingDays(end_date) >= 0) ? (
              <ApplicationButton
                isUserLoggedIn={isUserLoggedIn}
                handler={() => setShowModal(true)}
                isApplied={isUserApplied ? true : false}
              />
            ) : null}
          </div>
        </div>

        {refetchKey && showModal ? (
          <>
            <div className={styles["modal-overlay"]}></div>
            <ProjectDetailsModalContainer
              id={id}
              projectTitle={title}
              ownerId={ownerId}
              ownerName={ownerName}
              ownerChatDenial={ownerChatDenial}
              refetchKey={refetchKey}
              handleClose={() => setShowModal(false)}
              question={question}
            />
          </>
        ) : null}
        <BackToListButton name="プロジェクト" to="/project" max_width={960} />
        <RegistLeader
          message="eスポーツプロジェクトに応募しよう！"
          trackingLabel="projectDetail"
        />

        {relatedContents ? relatedContents : null}
      </main>

      <ContentReportModalContainer
        isModalShown={isReportModalShown}
        closeHandler={() => setIsReportModalShown(false)}
        pageType={PageTypes.Project}
        contentName={title}
      />
    </>
  );
};
